import React from 'react';
import { KYCVerification } from '../components/kyc';

const KYCPage = () => {
  return <KYCVerification />;
};

export default KYCPage;
